import type { Member } from '@hive/shared';
import { createContext, use } from 'react';

export const CurrentMemberContext = createContext<Member | null>(null);

/** The signed-in studio member. Only available inside the signed-in app. */
export function useCurrentMember(): Member {
  const member = use(CurrentMemberContext);
  if (!member) throw new Error('useCurrentMember must be used inside the signed-in app.');
  return member;
}
